<template src="./MonthlyReportContent.html"></template>

<script lang="ts">
import { defineComponent } from "vue";
import dateFormat from "dateformat";

export default defineComponent({
    props: {
        germanContent: { type: String, default: "" },
        germanSignature: { type: String, default: "" },
        englishContent: { type: String, default: "" },
        englishSignature: { type: String, default: "" }
    },
    computed: {
        fullDate(): string {
            return dateFormat(new Date(), "dd.mm.yyyy", true);
        },
        monthAndYearEnglish(): string {
            const now = new Date();
            const previousMonth = new Date(
                now.getFullYear(),
                now.getMonth() - 1,
                1
            );
            return dateFormat(previousMonth, "mmmm yyyy");
        },
        monthAndYearGerman(): string {
            const now = new Date();
            const previousMonth = new Date(
                now.getFullYear(),
                now.getMonth() - 1,
                1
            );
            const formatter = new Intl.DateTimeFormat("de-DE", {
                month: "long"
            });
            const month = formatter.format(previousMonth);
            const year = dateFormat(previousMonth, "yyyy");
            return `${month} ${year}`;
        }
    }
});
</script>

<style lang="scss" scoped src="./MonthlyReportContent.scss"></style>
